module.exports = __webpack_public_path__ + "img/MPX1.d4caa252.png";